module.exports = __webpack_public_path__ + "static/media/UPV_Logo-01.dfe668c5.png";